import { Tooltip } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  clearImpersonatorSession,
  getDefaultPathForRole,
  IMPERSONATOR_SESSION_KEY,
  isImpersonating,
  restoreSession,
} from "../../utils/sessionUtils";

const iconStyle = {
  cursor: "pointer" as const,
  fontSize: "24px",
  padding: "10px",
  width: "40px",
  height: "40px",
  marginLeft: "5px",
  color: "white",
  background: "black",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1,
};

const ImpersonationBack = () => {
  if (!isImpersonating()) {
    return null;
  }

  const handleBack = () => {
    const serializedSession = localStorage.getItem(IMPERSONATOR_SESSION_KEY);
    if (!serializedSession) {
      return;
    }
    const adminRoleName = restoreSession(serializedSession);
    clearImpersonatorSession();
    window.location.assign(getDefaultPathForRole(adminRoleName));
  };

  return (
    <Tooltip title="Back to admin">
      <div style={{ display: "inline-block" }}>
        <ArrowLeftOutlined style={iconStyle} onClick={handleBack} />
      </div>
    </Tooltip>
  );
};

export default ImpersonationBack;
